// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"e74a5e42","366":"6e4febb3","468":"6e4febb3"}[chunkId] + ".chunk.css";
};